import api from './api';
import { fetchPage } from './pagedParams';

const customerService = {
    getCustomers: async () => (await api.get('/admin/customers')).data,
    getCustomerById: async (id) => (await api.get(`/admin/customers/${id}`)).data,
    createCustomer: async (data) => (await api.post('/admin/customers', data)).data,
    updateCustomer: async (id, data) => (await api.put(`/admin/customers/${id}`, data)).data,
    toggleActive: async (id) => (await api.patch(`/admin/customers/${id}/toggle-active`)).data,
    deleteCustomer: async (id) => (await api.delete(`/admin/customers/${id}`)).data,

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getCustomersPage: (params) => fetchPage('/admin/customers/paged', params),

};

export default customerService;
